'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OptInPrompt = require('./components/OptInPrompt.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OptInPrompt).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/opt-in/lib/components/opt-in-prompt/index.js
// module id = 1441
// module chunks = 1